const common = require("lib/labels/_common");

// Home.group.services

module.exports = {
  title: common.licences,
  edit: common.edit,
  remove: common.remove,
  detailed: {
    service: {
      en: "Service",
      fr: "Service"
    },
    expiration: {
      en: "Expiration",
      fr: "Expiration"
    },
    maxProjects: {
      en: "Projects maximum",
      fr: "Maximum de projets"
    },
    api: {
      en: "API",
      fr: "API"
    }
  }
};
